import React from 'react'

export interface TableCellProps {
  children: React.ReactNode
  align?: 'left' | 'right' | 'center'
  className?: string
  isHeader?: boolean
  style?: React.CSSProperties
}

export function TableCell({ children, align = 'left', className = '', isHeader = false, style }: TableCellProps) {
  const Component = isHeader ? 'th' : 'td'

  const baseClasses = isHeader
    ? 'px-4 py-3 text-xs font-[550] text-muted-foreground tracking-wider bg-muted border-b border-border first:pl-4 last:pr-4'
    : 'px-4 py-3 text-[13px] text-foreground border-b border-border first:pl-4 last:pr-4 group-last:border-b-0'

  const alignClasses = {
    left: 'text-left',
    right: 'text-right',
    center: 'text-center',
  }

  return <Component className={`${baseClasses} ${alignClasses[align]} ${className}`} style={style}>{children}</Component>
}
